module.exports = __webpack_public_path__ + "img/ozturelogo-white.c62c4a82.png";